export const MIN_SCREEN_HEIGHT = 310;
export const MENU_ITEM_HEIGHT = 60;
export const FOOTER_HEIGHT = 40;
export const PADDING = 60;
